import { render } from "./TermsOfService.vue?vue&type=template&id=630ed894&scoped=true"
const script = {}

import "./TermsOfService.vue?vue&type=style&index=0&id=630ed894&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630ed894"]])

export default __exports__